import { Navigate, useLocation } from "react-router-dom";

/**
 * Post-event redirect for retired acquisition pages.
 *
 * Sends visitors to the historical closeout page without rendering any of the
 * legacy page content first. Harmless analytics parameters are preserved so
 * campaign attribution keeps working; everything else (promo codes, ticket
 * selections, referral offers) is dropped.
 */
const ALLOWED_PARAMS = /^(utm_[a-z_]+|gclid|gbraid|wbraid|fbclid|msclkid|ttclid|ref|source)$/i;

interface ArchiveRedirectProps {
  to: string;
}

const ArchiveRedirect = ({ to }: ArchiveRedirectProps) => {
  const location = useLocation();
  const incoming = new URLSearchParams(location.search);
  const kept = new URLSearchParams();

  incoming.forEach((value, key) => {
    if (ALLOWED_PARAMS.test(key)) kept.append(key, value);
  });

  const search = kept.toString();
  return <Navigate to={search ? `${to}?${search}` : to} replace />;
};

export default ArchiveRedirect;
